export const text = {
  SELF_REPORTED: 'Self-reported',
  WEIGHT: 'Weight',
  HEIGHT: 'Height',
  MARITAL_STATUS: 'marital status',
  RACIAL_BACKGROUND: 'racial background',
  SEARCH_VALUE: 'search value',
  GENDER_IDENTITY: 'gender identity',
  PHONE_NUMBER: 'phone number',
  ICD_CODE: 'icd code',
}

export const SEARCH_VALUE_MIN_LENGTH = 3

export const apiErrorCodes = {
  HeightInchesNotValid: 'HeightInchesNotValid',
  WeightPoundsNotValid: 'WeightPoundsNotValid',
  GenderIdentityNotValid: 'GenderIdentityNotValid',
  PatientNotFound: 'PatientNotFound',
  MaritalStatusNotValid: 'MaritalStatusNotValid',
  RacialBackgroundNotValid: 'RacialBackgroundNotValid',
  PhoneNumberNotValid: 'PhoneNumberNotValid',
  IcdCodeCountNotValid: 'IcdCodeCountNotValid',
}
